import React from 'react';
import { Container, Content, Column, Heading, Item, Title, Description, StoryMenu, StoryItem } from './MainNav.style';

const MainNav = ({activeMenu, isHoverNav}) => {

    const [isHoverMenu, setIsHoverMenu] = React.useState(false);

    return (
        <Container isVisible={isHoverNav || isHoverMenu} onMouseEnter={()=> setIsHoverMenu(true)} onMouseLeave={()=> setIsHoverMenu(false)}>
            <Content>
                { Array.isArray(activeMenu)
                    ? activeMenu.map((category, i) =>
                        <Column key={i}>
                            <Heading>{category.text}</Heading>
                            {category.navItems.map((ele, i) =>
                                <React.Fragment key={i}>
                                    { ele.header &&
                                        <Item href={ele.url}>
                                            <Title>{ele.title}<i className="fas fa-chevron-right"/></Title>
                                            <Description>{ele.description}</Description>
                                        </Item>
                                    }
                                </React.Fragment>
                            )}
                        </Column>
                    )
                    : <Column> {/** For STORIES menu */}
                        <StoryMenu>
                            {activeMenu && activeMenu.primary &&
                                <div>
                                    <StoryItem isPrimary={true} href='/story'><span>All Stories</span></StoryItem>
                                    {activeMenu.primary.map((item,i) =>
                                        <StoryItem isPrimary={true} key={i} href={item.url}><span>{item.title}</span></StoryItem>
                                    )}
                                </div> 
                            }
                             {activeMenu && activeMenu.secondary &&
                                <div>
                                    {activeMenu.secondary.map((item,i) =>
                                        <StoryItem key={i} href={item.url}><span>{item.title}</span></StoryItem>
                                    )}
                                </div> 
                            }
                        </StoryMenu>
                      
                    </Column>
                }
            </Content>
        </Container>
    );
}
 
export default MainNav;